import { Component as PComponent } from "preact";
import PropTypes from "prop-types";
import { locationThunk } from "../../../store/store";
import withConfiguration from "./withConfiguration";
import { withStoreConnection } from "../../components";
import { locationSelector } from "../../../store/selectors/selectors";
import Loading from "../Loading";
import OutOfOrderPage from "../../../routes/Location/OutOfOrderPage";

/**
 * A public higher-order component to access the imperative API
 */
export const withLocation = (Component, showLoader, showError) => {
	class HOC extends PComponent {
		componentDidMount() {
			const {configuration, location, locationStates} = this.props;

			if(!location && !locationStates.fetching) {
				locationThunk.getLocation(configuration.locationID, !showLoader);
			}
		}

		render({locationStates, location}) {
			if(showLoader && locationStates.fetching && !locationStates.fetched) {
				return <Loading />;
			}

			if(showError && locationStates.failed) {
				return <OutOfOrderPage error={locationStates.error}/>;
			}

			return (
				<Component
					location={location}
					{...this.props}
				/>
			);
		}

		static get displayName() {
			return "withLocation(" + (Component.displayName || Component.name) + ")"
		}

		static get wrappedComponent() {
			return Component;
		}

		static get propTypes() {
			return {
				configuration: PropTypes.object,
				location: PropTypes.object,
				locationStates: PropTypes.object,
			}
		}

		static get defaultProps() {
			return {
				location: null,
			}
		}
	}

	const mapStateToProps = state => {
		return {
			locationStates: locationSelector.selectStates(state),
			location: locationSelector.selectData(state),
		};
	};

	return withStoreConnection(mapStateToProps)(withConfiguration(HOC));
};

export default withLocation;
